"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AlertModalBase = _interopRequireDefault(require("../AlertModalBase"));

var _ConfirmationModal = require("./ConfirmationModal.styles");

var _strings = require("../../../constants/strings");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alertConfirmationModalConfirmationText = _strings.modalDefaults.alertConfirmationModalConfirmationText;

var ConfirmationModal = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ConfirmationModal, _React$PureComponent);

  var _super = _createSuper(ConfirmationModal);

  function ConfirmationModal() {
    _classCallCheck(this, ConfirmationModal);

    return _super.apply(this, arguments);
  }

  _createClass(ConfirmationModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _inStyleGuide = _this$props._inStyleGuide,
          className = _this$props.className,
          closeHandler = _this$props.closeHandler,
          confirmationText = _this$props.confirmationText,
          isOpen = _this$props.isOpen,
          modalRole = _this$props.modalRole,
          primaryText = _this$props.primaryText,
          secondaryText = _this$props.secondaryText,
          title = _this$props.title;
      return /*#__PURE__*/_react.default.createElement(_AlertModalBase.default, {
        _inStyleGuide: _inStyleGuide,
        className: className,
        closeHandler: function closeHandler() {},
        dataTestId: "alert-confirmation-modal-modal-wrapper",
        isOpen: isOpen,
        modalRole: modalRole,
        primaryText: primaryText,
        secondaryText: secondaryText,
        title: title
      }, /*#__PURE__*/_react.default.createElement(_ConfirmationModal.StyledButtonContainer, {
        "data-test-id": "alert-confirmation-modal-button-container"
      }, /*#__PURE__*/_react.default.createElement(_ConfirmationModal.StyledButton, {
        onClick: closeHandler,
        dataTestId: "alert-confirmation-modal-confirmation-button"
      }, confirmationText)));
    }
  }]);

  return ConfirmationModal;
}(_react.default.PureComponent);

_defineProperty(ConfirmationModal, "propTypes", {
  /** Styleguide override */
  _inStyleGuide: _propTypes.default.bool,

  /** Styling classname */
  className: _propTypes.default.string,

  /** Raises the close interaction to a parent */
  closeHandler: _propTypes.default.func.isRequired,

  /** Text for confirmation button */
  confirmationText: _propTypes.default.string,

  /** Toggle for controlled open */
  isOpen: _propTypes.default.bool.isRequired,

  /** Determines the style of the modal */
  modalRole: _propTypes.default.string,

  /** Text for bolded content text */
  primaryText: _propTypes.default.string,

  /** Text for secondary content text */
  secondaryText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),

  /** Text for modal header */
  title: _propTypes.default.string
});

_defineProperty(ConfirmationModal, "defaultProps", {
  _inStyleGuide: false,
  className: '',
  confirmationText: alertConfirmationModalConfirmationText,
  modalRole: 'info',
  primaryText: undefined,
  secondaryText: '',
  title: ''
});

var _default = ConfirmationModal;
exports.default = _default;